module.exports = __webpack_public_path__ + "img/amazon-logo@2x.14e2c189.png";